import Axios from 'axios'

const deskBooking = {
  getBookingsOfCurrentUser (start, finish) {
    return Axios.get(`/api/v1/bookings?start=${start}&finish=${finish}`)
  },
  getGuestsBookings (start, finish) {
    return Axios.get(`/api/v1/guest-bookings?start=${start}&finish=${finish}`)
  }
}

export default deskBooking
